/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { FileUploadUrlResponse } from './fileUploadUrlResponse';

export type GenericApiResponseFileUploadUrlResponseData = FileUploadUrlResponse | null;
